import { MapCoreActions } from '@tmapy/mapcore';

import { SET_MAP_DEFAULT_STATE } from './constants';

type ActionSetMapDefaultState = ReturnType<typeof actionSetMapDefaultState>;

export type MapActions = MapCoreActions | ActionSetMapDefaultState;

export const actionSetMapDefaultState = () => ({ type: SET_MAP_DEFAULT_STATE }) as const;
